/**
 * File navigation.js.
 */

export function heroCards() {
    const cards = document.querySelectorAll('.hero-block .card.swiper-slide');

    if (cards) {
        cards.forEach((card) => {
            card.addEventListener('click', () => {
                card.classList.toggle('active');
            });

            // Mouseenter: add "hover" class
            card.addEventListener('mouseenter', () => {
                card.classList.add('active');
            });

            // Mouseleave: remove "hover" class
            card.addEventListener('mouseleave', () => {
                card.classList.remove('active');
            });
        });

        document.addEventListener('click', (e) => {
            cards.forEach((card) => {
                if (!card.contains(e.target)) {
                    card.classList.remove('active');
                }
            });
        });
    }
}